import type { App } from 'vue'
import { setupWatermarkDirective } from '@/directives/watermark'
import { setupInfiniteScrollDirective } from '@/directives/infinite-scroll'

export function setupGlobDirectives(app: App) {
  setupWatermarkDirective(app)
  setupInfiniteScrollDirective(app)
}
